export default "__VITE_ASSET__DrQCkWfw__"